module.exports = __webpack_public_path__ + "static/img/车辆管理.90e1f8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buliding/车辆管理.png
// module id = 1YAX
// module chunks = 1